<!--dynamic header-->
<h1 mat-dialog-title>{{ getPageHeading() }}</h1>
<!--basic feedstock info (name, material type, characteristics, quantities)-->
<mat-dialog-content>
  <app-feedstock-basic-info
    *ngIf="materialCategoriesLoaded"
    [projectInputDisplay]="true"  
    [feedstock]="feedstock"
    (changesMadeNotifier)="onChangesMade()"
    [feedstockUpdatedNotifier]="feedstockUpdatedNotifier"
    (formIsValid)="basicInfoValid = $event">
  </app-feedstock-basic-info>
  <h3 *ngIf="!materialCategoriesLoaded" class="center">
    {{'PROJECT.FEEDSTOCK.LOADING' | anessaTranslation: trigger}}
  </h3>
</mat-dialog-content>
<!--save cancel buttons-->
<mat-dialog-actions class="fatbuttongroup">
  <button
    [disabled]="!basicInfoValid"
    mat-button
    class="btn-fat btn-green"
    type="button"
    (click)="onSaveClick()"
    anessaTranslation="PROJECT.COMMON.SAVE">
  </button>
  <button
    mat-button
    class="btn-fat btn-red"
    type="button"
    (click)="onCancelClick()"
    anessaTranslation="PROJECT.COMMON.CANCEL">
  </button>
</mat-dialog-actions>
